import { render, staticRenderFns } from "./StockTransfers.vue?vue&type=template&id=7e577dfb&"
import script from "./StockTransfers.vue?vue&type=script&lang=js&"
export * from "./StockTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports